import Image from "next/image";
import Link from "next/link";
import { AspectRatio } from "../ui/aspect-ratio";
import TopicTag from "./topic-tag";
import { cn } from "~/lib/utils";
function simpleHash(str) {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  // Ensure the result is a positive number within 0-99
  return Math.abs(hash) % 100;
}
export const getFeatureImage = (blogCategoryKey, key) => {
  const id = simpleHash(key);
  if (blogCategoryKey === "insights") {
    const insightsImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIGHTS_1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIGHTS_2.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIGHTS_3.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIGHTS_4.png",
    ];
    return insightsImgs[id % insightsImgs.length];
  } else if (blogCategoryKey === "collaborations") {
    const collaborationsImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/COLLABORATIONS_1.png",
    ];
    return collaborationsImgs[id % collaborationsImgs.length];
  } else if (blogCategoryKey === "inside-outshift") {
    const insideImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIDEOUTSHIFT_1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/INSIDEOUTSHIFT_2.png",
    ];
    return insideImgs[id % insideImgs.length];
  } else if (blogCategoryKey === "product") {
    const productImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/PRODUCT_1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/PRODUCT_2.png",
    ];
    return productImgs[id % productImgs.length];
  } else if (blogCategoryKey === "ai-ml") {
    const productImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/ai-default-img-1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/ai-default-img-2.png",
    ];
    return productImgs[id % productImgs.length];
  } else if (blogCategoryKey === "quantum") {
    const productImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/quantum-default-img-1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/quantum-default-img-2.png",
    ];
    return productImgs[id % productImgs.length];
  } else if (blogCategoryKey === "research") {
    const productImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/research-default-img-1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/research-default-img-2.png",
    ];
    return productImgs[id % productImgs.length];
  } else if (blogCategoryKey === "in-depth-tech") {
    const productImgs = [
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/tech-default-img-1.png",
      "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/tech-default-img-2.png",
    ];
    return productImgs[id % productImgs.length];
  } else {
    return "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/insights.png";
  }
};
const BlogCard = ({
  blog,
  size,
  forceHeight = "null",
  showCategory = true,
  categoryOnTop = false,
  imageAlign = "center",
}) => {
  const blogImage = blog?.thumbnail?.url;
  const blogCategoryKey = blog?.blog_category?.key;
  const isAuthorLayout = imageAlign === "left";

  return (
    <div className={cn("flex flex-col gap-5", isAuthorLayout && "h-full")}>
      <Link
        href={`/blog/${blogCategoryKey?.toLowerCase()}/${blog?.key?.toLowerCase()}`}
        className={cn("group", isAuthorLayout && "flex flex-grow flex-col")}
      >
        {categoryOnTop && (
          <div className="flex gap-3 py-6">
            <Image
              unoptimized
              src={
                blog?.blog_category?.icon?.url
              }
              alt="Icon"
              width="25"
              height="25"
            />
            <h6 className="font-h6 uppercase">
              {blog?.blog_category?.title}
            </h6>
          </div>
        )}
        <div
          className={cn(
            "relative overflow-hidden rounded-xl",
            imageAlign === "left" ? "w-full" : "mx-auto",
            size == "menu" ? "aspect-[15/7]" : "aspect-video md:min-h-[180px]",
            forceHeight,
          )}
        >
          <div className="">
            <AspectRatio ratio={size == "menu" ? (300 / 140) : (400 / 220)}>
              <Image
                unoptimized
                src={blogImage || getFeatureImage(blogCategoryKey, blog?.key)}
                fill
                alt="Featured home blog"
                className={cn(
                  "rounded-xl object-cover transition-all duration-700 group-hover:scale-105",
                  imageAlign === "left" ? "w-full" : "w-[90%]",
                )}
                sizes="100%"
              />
            </AspectRatio>
          </div>
        </div>
        {blog?.blog_category && size !== "menu" && showCategory && !categoryOnTop && (
          <div className="mb-1 flex gap-3 py-6">
            <Image
              unoptimized
              src={
                blog?.blog_category?.icon?.url
              }
              alt="Icon"
              width="25"
              height="25"
            />
            <h6 className="font-h6 uppercase">
              {blog?.blog_category?.title}
            </h6>
          </div>
        )}
        {(!showCategory || categoryOnTop) && <div className="py-2"></div>}
        <h3
          className={
            size == "menu"
              ? "font-p pt-2 text-[#A6A6A6]"
              : size == "lg"
                ? "font-h3 mb-5"
                : "font-h2 md:font-h5  lg:text-[26px]"
          }
        >
          {blog?.title}
        </h3>
      </Link>
      <div
        className={cn(
          "flex flex-wrap gap-5",
          isAuthorLayout
            ? "mt-auto pt-2 md:pt-6"
            : "bottom-0 md:absolute md:pt-14",
        )}
      >
        {blog?.blog_topics &&
          size !== "menu" &&
          blog?.blog_topics.map((t, i) => <TopicTag topic={t} key={i} />)}
      </div>
    </div>
  );
};

export default BlogCard;
